export var IncomeTypesOthers;
(function (IncomeTypesOthers) {
    IncomeTypesOthers["SuperAnnuityPension"] = "SUPER_ANNUITY_PENSION";
    IncomeTypesOthers["WorkersCompensation"] = "WORKERS_COMPENSATION";
    IncomeTypesOthers["ForeignIncome"] = "FOREIGN_INCOME";
    IncomeTypesOthers["ChildMaintenance"] = "CHILD_MAINTENANCE";
    IncomeTypesOthers["CentrelinkBenefit"] = "CENTRELINK_BENEFIT";
    IncomeTypesOthers["OtherIncome"] = "OTHER_INCOME";
})(IncomeTypesOthers || (IncomeTypesOthers = {}));
//# sourceMappingURL=IncomeTypesOthers.js.map